import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Card } from 'react-bootstrap';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import Flex from '../../common/Flex';
import AppContext from '../../context/Context';

function EmailFooter({
  totalItems,
  emailIndex,
  canNextPage,
  canPreviousPage,
  nextPage,
  prevPage,
}) {
  const {
    config: { isRTL },
  } = useContext(AppContext);
  const navigate = useNavigate();

  return (
    <Card.Footer as={Flex} justifyContent="between" alignItems="center">
      <div>
        <small>
          {emailIndex}
          {' '}
          of
          {totalItems}
        </small>
        <Button
          variant="falcon-default"
          size="sm"
          className="ms-1 ms-sm-2"
          disabled={!canPreviousPage}
          onClick={() => {
            navigate(prevPage);
          }}
        >
          <FontAwesomeIcon icon={isRTL ? faChevronRight : faChevronLeft} />
        </Button>
        <Button
          variant="falcon-default"
          size="sm"
          className="ms-1 ms-sm-2"
          disabled={!canNextPage}
          onClick={() => {
            navigate(nextPage);
          }}
        >
          <FontAwesomeIcon icon={isRTL ? faChevronLeft : faChevronRight} />
        </Button>
      </div>
    </Card.Footer>
  );
}

EmailFooter.propTypes = {
  totalItems: PropTypes.number.isRequired,
  emailIndex: PropTypes.number.isRequired,
  canNextPage: PropTypes.bool.isRequired,
  canPreviousPage: PropTypes.bool.isRequired,
  nextPage: PropTypes.func.isRequired,
  prevPage: PropTypes.func.isRequired,
};

export default EmailFooter;
